import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    CustomLabelSmallRegular,
    CustomLabelXSmallRegular
} from "../common/CustomLabel";
import Slider from "react-slick/lib";
import Paper from "@mui/material/Paper/Paper";
import Box from "@mui/material/Box/Box";
import SAMPLE_PROFILE from "../../assets/images/sample-profile.png";
import CHAT_RIGHT from "../../assets/images/chat-right.png";
// import RATING from "../../assets/images/rating.png";
// import SAMPLE_PROFILE2 from "../../assets/images/project2.png";
// import SAMPLE_PROFILE3 from "../../assets/images/profile3.png";
import React from "react";
import AAUKASHA from "../../assets/testimonials/Aaukasha.webp";
import BABAK from "../../assets/testimonials/BabakWethr.webp";
import EMAL from "../../assets/testimonials/EmalKhan.webp";
import ETHAN from "../../assets/testimonials/EthanKarian.webp";
// import IVAN from "../../assets/testimonials/IvanVascas.webp";
import NACHO from "../../assets/testimonials/NachoBeloqui.webp";
import BLUECHIP from "../../assets/testimonials/BluechipWorldDubaiUAE.webp";
import Rating from '@mui/material/Rating';

const testimonialData = [
    {
        image: EMAL,
        company: "BabezLondon",
        author: "Emal Khan, Founder of BabezLondon.",
        testimonial: "Ostryx transformed our e-commerce platform, delivering a sleek, user-friendly shopping experience with a powerful admin panel. Their ongoing support and dedication have kept our business running smoothly for years. Highly recommended!"
    },
    {
        image: BABAK,
        company: "Checker App",
        author: "Babak Wethr, Founder of The Checker App.",
        testimonial: "Ostryx built an efficient, multi-role hotel cleaning system that completely streamlined our operations. Their expertise in mobile and web development helped us improve efficiency and coordination, making our workflow smooth!"
    },
    {
        image: ETHAN,
        company: "SipSkip",
        author: "Ethan Karian, Founder of SipSkip.",
        testimonial: "OSTRYX delivered beyond our expectations. They built a robust platform that handles our complex requirements effortlessly. Their technical expertise and proactive approach made the development process smooth and efficient."
    },
    {
        image: BLUECHIP,
        company: "DXB OS App",
        author: "Bluechip Client Representative.",
        testimonial: "The team at OSTRYX demonstrated exceptional skill in developing our airport operations system. Their attention to security and performance requirements was impressive, delivering a solution that met all our stringent standards."
    },
    {
        image: NACHO,
        company: "El-Padel",
        author: "Nacho Beloqui, Founder of El-Padel.",
        testimonial: "OSTRYX's expertise in sports facility management systems is outstanding. They created a comprehensive booking and management platform that has significantly improved our operational efficiency."
    },
    {
        image: SAMPLE_PROFILE,
        company: "Nuncmitto",
        author: "Adi Jetson, Founder of Nuncmitto.",
        testimonial: "The digital food gifting platform developed by OSTRYX has revolutionized how we connect restaurants with customers. Their innovative approach and technical excellence made our vision a reality."
    },
    {
        image: AAUKASHA,
        company: "Deerpe",
        author: "Aaukasha, Founder of Deerpe.",
        testimonial: "OSTRYX's development of our real estate platform exceeded our expectations. Their understanding of the market and technical capabilities delivered a solution that sets us apart in the industry."
    }
    // ... add other testimonials similarly
];

const TestimonialCard = ({ data }) => (
    <div style={{ height: '100%' }}>
        <Paper sx={{
            width: "100%",
            height: "100%",
            marginBottom: "10px",
            background: "#FFFFFF",
            borderRadius: 10,
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Grid 
                container 
                direction="column"
                sx={{
                    padding: { xs: "15px 15px", md: "20px 20px" },
                    height: '100%',
                    minHeight: { xs: '180px', md: '500px' , lg: '400px'}
                }}
            >
                <Grid item container spacing={1} sx={{ mb: { xs: 1, md: 2 } }}>
                    <Grid item>
                        <Box component="img" 
                            src={data.image}
                            alt={data.author}
                            sx={{
                                width: {xs: 32, md: 56},
                                height: {xs: 32, md: 56},
                                borderRadius: "50%",
                                objectFit: 'cover'
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Grid container 
                            justifyContent="center" 
                            alignItems="start"
                            direction="column" 
                            sx={{ height: "100%" }}
                        >
                            <Grid item>
                                <CustomLabelSmallRegular text={data.company}/>
                            </Grid>
                            <Grid item sx={{ mt: 0.5 }}>
                                <CustomLabelXSmallRegular 
                                    opacity="50%" 
                                    color="#333333"
                                    text={data.author}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs>
                        <Grid container justifyContent="flex-end">
                            <Box component="img" 
                                src={CHAT_RIGHT}
                                alt={"Chat Right"}
                                sx={{
                                    width: {xs: "24px", md: "32px"},
                                    height: 'auto'
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item 
                    sx={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'flex-start',
                        mb: { xs: 1, md: 'auto' }
                    }}
                >
                    <CustomLabelMediumRegular 
                        normal={true}
                        text={data.testimonial}
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: { xs: 4, md: 6 },
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: { xs: 1.4, md: 1.5 },
                            textAlign: 'justify',
                        }}
                    />
                </Grid>

                <Grid item 
                    container 
                    justifyContent="left"
                >
                    <Rating 
                        value={5} 
                        readOnly 
                        sx={{
                            color: '#F6BB06',
                            '& .MuiRating-icon': {
                                fontSize: { xs: '18px', md: '24px' }
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </Paper>
    </div>
);

const WhatOurClientSays = ({testimonalsRef, settings}) => {
    const updatedSettings = {
        // dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: false,
        className: "equal-height-slides",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    // dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    // dots: true
                }
            }
        ]
    };

    return (
        <Grid container 
            sx={{
                marginTop: "0px", 
                background: "#FAF7FF", 
                paddingBottom: {xs: "30px", md: "50px"},
                px :{ xs: 1, md: 5}
            }}
            justifyContent="center"
        >
            <Grid item container justifyContent="center" 
                sx={{
                    marginTop: {xs: "20px", md: "50px"}, 
                    textAlign: "center"
                }}
            >
                <CustomLabelMediumBold text="TESTIMONIALS" fontWeight={700} color="#5E17EB"/>
            </Grid>
            
            <div ref={testimonalsRef} tabIndex={0}></div>

            <Grid item container justifyContent="center" xs={10} sx={{ mt: 1 }}>
                <CustomLabelMediumRegular 
                    normal={false}
                    text="We've partnered with global leaders to deliver innovative solutions across industries."
                />
            </Grid>

            <Grid item xs={12}
                sx={{
                    padding: {xs: "0px 10px", md: "0px 30px"}, 
                    marginTop: {xs: "20px", md: "40px"}
                }}
            >
                <div className="slider-container">
                    <Slider {...updatedSettings}>
                        {testimonialData.map((testimonial, index) => (
                            <TestimonialCard key={index} data={testimonial} />
                        ))}
                    </Slider>
                </div>
            </Grid>
        </Grid>
    );
};

// const styles = `
// .slider-container .slick-track {
//     display: flex !important;
//     align-items: stretch;
// }

// .slider-container .slick-slide {
//     height: auto;
//     padding: 0 10px;
// }

// .slider-container .slick-slide > div {
//     height: 100%;
// }

// .equal-height-slides .slick-slide > div {
//     height: 100%;
// }

// .equal-height-slides .slick-track {
//     display: flex;
//     align-items: stretch;
// }
// `;

export default WhatOurClientSays;
